/*
 * Copyright (c) 2018 Edelo Pte Ltd - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Elton Lam
 * Date: Fri Apr 06 2018
 */
(function ($) {
    var Footer = function (element, options) {
        var footer = $(element);
        var settings = $.extend({
            type: 'curtain',
            content: 'content',
            zIndexTop: 1,
            zIndexBottom: 0
        }, options || {});
        var resizeTimer = null;
        var destroyed = false;
        var initialized = false;

        function destroy() {    
            $(window).off("scroll", scroll);
            $(window).off("resize", resize);
            $(window).off("load", checkBottom);
            $(settings.content).css('margin-bottom', '');
            footer.css({
                'position': '',
                'z-index': '',
                'bottom': ''
            });
            destroyed = true;
            footer.removeData('Footer');
        }

        function checkBottom() {            
            if (destroyed) return;
            
            // console.log($(settings.content).height());
            // console.log($(window).height() - $('sticky-header').height())
            if ($(window).scrollTop() + $(window).height() >= $(document).height() + 20) {   
                footer.css({
                    'position': 'fixed',
                    'z-index': settings.zIndexTop,
                    'bottom': 0
                });
                return;
            } 
            

            footer.css({
                'position': 'fixed',
                'z-index': settings.zIndexBottom,
                'bottom': 0
            });
        }

        function scroll() {
            if (!initialized) return;
            checkBottom();
        }

        function resize() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                checkBottom();
            }, 100);
        }

        function load() {
            checkBottom();

            footer.css({'opacity': 1 });
            initialized = true;
        }

        $(document).ready(function() {             
            var footerHeight = footer.outerHeight(true);
            $(settings.content).css('margin-bottom', footerHeight + 'px');
            // checkBottom();
        });

        // $(window).load(load);
        $(window).resize(resize);
        $(window).scroll(scroll);

        return {
            load: load,
            destroy: destroy,
            checkBottom: checkBottom
        };
    };

    $.fn.footer = function (options) {
        return this.each(function () {
            var element = $(this);

            // Return early if this element already has a plugin instance
            if (element.data('Footer')) return;

            // pass options to plugin constructor
            var footer = new Footer(this, options);

            // Store plugin object in this element's data
            element.data('Footer', footer);
        });
    };
})(jQuery);